import { Auth, CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { clearSessionActiveOrganizationId } from '../activeOrganizationStorage';
import logger from '../logger';

export const googleSignIn = async () => {
  return await Auth.federatedSignIn({
    provider: CognitoHostedUIIdentityProvider.Google,
  })
    .then((response) => logger('log', response))
    .catch((error) => logger('log', error));
};
export const signOut = async () => {
  clearSessionActiveOrganizationId();
  return await Auth.signOut()
    .then(() => true)
    .catch(() => false);
};

export const isCognitoSessionActive = async () => {
  return await Auth.currentAuthenticatedUser()
    .then((response) => response?.attributes)
    .catch(() => null);
};
